import { SystemStyleObject } from '@chakra-ui/react';

const baseStyle: SystemStyleObject = {
  fontFamily: `Quicksand`,
  color: `gray.600`,
  lineHeight: 1.8,
};

const variants: SystemStyleObject = {
  xl: {
    fontSize: `text.1`,
  },
  lg: {
    fontSize: `text.2`,
  },
  md: {
    fontSize: `text.3`,
  },
  sm: {
    fontSize: `text.4`,
  },
  xs: {
    fontSize: `text.5`,
  },
};

const defaultProps: SystemStyleObject = {
  variant: `md`,
};

export const Text = {
  baseStyle,
  variants,
  defaultProps,
};
